import React from "react";
import { RefundOptions } from "../Components";

export const RefundOptionsPage = () => {
  return <RefundOptions />;
};
